import type { GatsbyBrowser } from 'gatsby'

import Theme from './src/components/Theme/theme'
import './src/global.css'
import './src/components/builder-components'

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => <Theme>{element}</Theme>
